export default __webpack_public_path__ + "static/media/foodtrader-logo.e6f9ba1a.svg";